var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/streamfield/streamfield.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import Button from '../button/button';
import HStack from '../hstack/hstack';
import IconButton from '../icon-button/icon-button';
import Stack from '../stack/stack';
import Text from '../text/text';
const messages = defineMessages({
  add: {
    "id": "streamfield.add",
    "defaultMessage": "Add"
  },
  remove: {
    "id": "streamfield.remove",
    "defaultMessage": "Remove"
  }
});

/** Type of the inner Streamfield input component. */

/** List of inputs that can be added or removed. */
const Streamfield = ({
  values,
  label,
  hint,
  onAddItem,
  onRemoveItem,
  onChange,
  component: Component,
  maxItems = Infinity
}) => {
  const intl = useIntl();
  const handleChange = i => {
    return value => {
      const newData = [...values];
      newData[i] = value;
      onChange(newData);
    };
  };
  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 7
    }
  }, label && /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 19
    }
  }, label), hint && /*#__PURE__*/React.createElement(Text, {
    size: "xs",
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 18
    }
  }, hint)), values.length > 0 && /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 9
    }
  }, values.map((value, i) => /*#__PURE__*/React.createElement(HStack, {
    key: i,
    space: 2,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Component, {
    onChange: handleChange(i),
    value: value,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 15
    }
  }), onRemoveItem && /*#__PURE__*/React.createElement(IconButton, {
    iconClassName: "w-4 h-4",
    className: "bg-transparent text-gray-400 hover:text-gray-600",
    src: require('@tabler/icons/x.svg'),
    onClick: () => onRemoveItem(i),
    title: intl.formatMessage(messages.remove),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 17
    }
  })))), onAddItem && /*#__PURE__*/React.createElement(Button, {
    icon: require('@tabler/icons/plus.svg'),
    onClick: onAddItem,
    disabled: values.length >= maxItems,
    theme: "ghost",
    block: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 9
    }
  }, intl.formatMessage(messages.add)));
};
export default Streamfield;